import { Radio } from "antd";
import styles from "./styles.module.scss";
import classNames from "classnames";

interface Props {
  handleSelect: () => void;
  isSelected: boolean;
  children: React.ReactNode;
}

export function RadioInput({ handleSelect, isSelected, children }: Props) {
  return (
    <div
      className={classNames(styles.radioContainer, {
        [styles.selected]: isSelected,
      })}
      onClick={handleSelect}>
      <Radio checked={isSelected} />
      <span className={styles.radioContent}>{children}</span>
    </div>
  );
}
